






























































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import SnippetItem from "./components/widgets/SnippetItem.vue";
import { checkIsOpen, fetchSiteData, registerLogout } from "./api/methods";
import { bus } from "./main";
import { WindowState, UserState, SiteState, SubmissionState } from "./store/types";
import { notEmptyString } from "./api/validators";
import labels from "./settings/labels";
import { formatMinSecs } from "./api/helpers";
import { backend } from "./.config";

const nsWindow = "window";
const nsUser = "user";

@Component({
  components: {
    SnippetItem,
  },
})
export default class App extends Vue {
  @State("window") window: WindowState;
  @State("user") user: UserState;
  @State("submission") submission: SubmissionState;
  @State("site") site: SiteState;
  @Action("assignSite", { namespace: "site" }) assignSite: Function;
  @Action("assignTimedOut", { namespace: "site" }) assignTimedOut: Function;
  @Action("assignWindow", { namespace: nsWindow }) assignWindow: Function;
  @Action("assignUser", { namespace: nsUser }) assignUser: Function;

  isLoggedIn = false;

  showMainNav = false;

  showOverlay = false;

  overlayClosing = false;

  version = 0.21;

  title = "AcrossRCA2024";

  lastActive = new Date().getTime();

  mainMenuItems = [
    // { to: '/', label: this.title, access: 'loggedin' },
    { to: "/login", label: "Logout", icon: "login", access: "loggedout" },
  ];

  isLoaded = false;

  showingToast = false;

  mounted() {
    this.assignWindow();
  }

  created() {
    // reset MSAL status on reload
    window.sessionStorage.clear();
    this.$ls.remove('msal-loaded');
    this.registerActivity();
    const storedVersion = this.$ls.get("version");
    const currVer = storedVersion ? storedVersion : 0;
    if (currVer !== this.version) {
      this.clearCaches();
      setTimeout(() => {
        this.$ls.set("version", this.version);
      }, 1000);
    }
    const user = this.$ls.get("user");
    if (user instanceof Object) {
      const { active } = user;
      if (active) {
        this.isLoggedIn = true;
        this.assignUser(user);
        if (this.isSignInRoute()) {
          this.$router.push("/");
        }
      }
    } else {
      if (this.isSignInRoute() === false) {
        const { hash } = window.location;
        this.$router.push({
          path: "/login",
          hash,
        });
      }
    }
    bus.$on("login", (valid: boolean) => {
      if (valid) {
        this.isLoggedIn = true;
        this.registerActivity();
      }
    });
    bus.$on("escape", () => {
      this.closeOverlay();
    });
    bus.$on("active", () => {
      this.registerActivity();
    });
    bus.$on("form-click",this.handleClick);
    this.sync();
    setTimeout(this.checkOpen, 1000);
    const mins = 60 * 1000;
    setInterval(this.checkOpen, 5 * mins);
    setTimeout(this.matchTitle, 500);
    window.addEventListener("keydown", this.handleKeyDown);
    const toMs = this.$ls.get('timedout');
    if (toMs) {
      const msVal = parseInt(toMs, 10);
      if (msVal > 1000) {
        // show message is 
        if ((Date.now() - msVal) < 5000) {
          this.assignTimedOut(true);
        } else {
          this.$ls.remove('timedout');
        }
      }
    }
  }

  checkOpen() {
    checkIsOpen(this.user._id).then((data) => {
      if (data instanceof Object) {
        this.handleOpenData(data)
      }
    });
    setTimeout(this.checkInactive, 10 * 1000);
    
  }

  handleOpenData(data = null) {
    const { open, hasOpened, deadline } = data;
    const keys = Object.keys(data);
    const isOpen = hasOpened === true;
    const hasFinished = open === false;
    this.site.settings.set("submissions_open", isOpen);
    this.site.settings.set("submissions_deadline", deadline);
    //const deadlineTS = new Date("2021-04-08T14:40:00.00Z").getTime();
    const deadlineTS = new Date(deadline).getTime();
    const currTs = new Date().getTime();
    const secsToGo = (deadlineTS - currTs) / 1000;
    this.$ls.set("status", {
      open: isOpen,
      deadline,
    });
    let logOutNow = false;
    let inactive = false;
    if (keys.includes("accountChecked") && keys.includes("active")) {
        logOutNow = !data.active;
        if (!logOutNow) {
          inactive = true;
        }
    }
    if (hasFinished) {
      logOutNow = this.submission.deadlineException === false;
    }
    if (this.isLoggedIn && !logOutNow && this.submission.deadlineException === false) {
      if (secsToGo < (30 * 60)) {
        const time = formatMinSecs(secsToGo);
        const message = `${time} to go. Applications will close soon.`;
        this.toast(message, 5000, "is-warning");
      }
    }
    if (logOutNow && this.isLoggedIn) {
      const reasonKey = inactive? 'inactive' : 'deadline';
      const labelKey = `site__${reasonKey}_logout_message`
      const message = this.site.label(labelKey);
      this.toast(message, 6000, "is-warning");
      // log out from app and MSAL
      bus.$emit("save", {
        msg: "",
        delay: 0,
        saveWork: true
      });
      setTimeout(this.logoutFull, 12000);
    } else {
      this.$emit("checked-status", true);
    }
  }

  registerActivity() {
    this.lastActive = new Date().getTime();
  }

  maxInactiveTs(): number {
    const maxInactiveMins = this.site.settings.get('logout_mins');
    const maxLogoutMins = typeof maxInactiveMins === 'number' && maxInactiveMins > 5? maxInactiveMins : 15;
    //const maxLogoutMins = 1;
    return maxLogoutMins * 60 * 1000;
  }

  checkInactive() {
    const maxInactiveCheckIntervalMs = 10000;
    if (this.isLoggedIn && this.lastActive >= maxInactiveCheckIntervalMs) {
      const currTs = new Date().getTime();
      const maxInactive = this.maxInactiveTs();
      const timeOutTs = this.lastActive + maxInactive;
      if (currTs > timeOutTs) {
        this.saveAndLogOut(5000, true)
      }
    }
  }

  saveAndLogOut(delay = 2000, timedOut = false) {
    const saveDelay = delay > 3000 ? delay - 3000 : 0;
    bus.$emit("save", {
      msg: "Saving submission before logout",
      delay: saveDelay,
      saveWork: true
    });
    setTimeout(() => {
      if (timedOut) {
        this.assignTimedOut(true);
        this.$ls.set('timedout', Date.now());
      }
      this.logoutFull();
    }, delay);
  }

  logoutDirect() {
    this.toast("Logging out", 2000);
    this.saveAndLogOut(1000, false);
  }

  isSignInRoute() {
    const { pathname } = window.location;
    const first = pathname.substring(1).split("/").shift();
    switch (first) {
      case "login":
      case "register":
      case "reset":
      case "forgotten":
        return true;
      default:
        return false;
    }
  }

  sync() {
    fetchSiteData(backend.mode).then((data) => {
      if (data instanceof Object) {
        this.assignSite({ ...data, labels });
        setTimeout(() => {
          const open = this.site.settings.get("submissions_open");
          const deadline = this.site.settings.get("submissions_deadline");
          this.$ls.set("status", { open, deadline });
        }, 125);
        this.$emit("checked-status", true);
        this.isLoaded = true;
      }
    });
  }

  get hasSiteData() {
    return this.site.snippets.length > 1;
  }

  toast(message: string, duration = 5000, type = "is-success") {
    const numTst = document.querySelectorAll('.notices .toast').length;
    if (numTst < 1 && !this.showingToast) {
      this.showingToast = true;
      this.$buefy.toast.open({
        duration,
        message,
        position: "is-bottom",
        type,
      });
      setTimeout(() => {
        this.showingToast = false;
      }, duration + 2000);
    }
  }

  storageKeys() {
    let keys = [];
    if (window.localStorage instanceof Object) {
      keys = Object.keys(window.localStorage).map((k) =>
        k.replace(/^ap_/, "")
      );
    }
    return keys;
  }

  logout() {
    this.$ls.remove("user");
    this.$ls.remove("current-user");
    this.$ls.remove("submission");
    bus.$off('show-message');
    const keys = this.storageKeys();
    if (keys.length > 0) {
      keys.forEach(sk => {
        if (sk.includes('link') || sk.includes('work')) {
          this.$ls.remove(sk);
        }
      });
    }
    if (this.submission.slug) {
      registerLogout(this.user._id, this.submission.slug);
    }
    this.isLoggedIn = false;
    const { path } = this.$route;
    if (path !== "/login") {
      this.$router.push("/login");
    }
  }

  // log out from app and MSAL
  logoutFull() {
    this.logout();
    setTimeout(() => {
      bus.$emit('msal-logout', true);
      /* setTimeout(() => {
        window.location.reload();
      }, 250); */
    }, 1000);
  }

  handleKeyDown(e) {
    switch (e.which) {
      case 37:
        bus.$emit("prev", true);
        break;
      case 39:
        bus.$emit("next", true);
        break;
      case 27:
        bus.$emit("escape", true);
        break;
    }
  }

  handleClick(e) {
    const { target } = e;
    if (target instanceof HTMLElement) {
      const { tagName } = target;
      const tn = tagName.toLowerCase();
      
      if (["main", "header","nav", "h1", "img","form","label"].includes(tn) || (tn === "div" && (target.id === "root" || target.classList.length < 1 || target.classList.contains("info") === false))) {
        const par = target.parentNode as HTMLElement;
        const parCl = par.classList;
        const tCl = target.classList;
        if (["sort-list","embed-widget","tab-item", "web-resource"].some(key => tCl.contains(key) || parCl.contains(key)) === false) {
          bus.$emit("escape", true);
        }
      }
    }
  }

  /* toggleMainNav() {
    this.showMainNav = !this.showMainNav;
  } */

  closeOverlay() {
    this.overlayClosing = true;
    setTimeout(() => {
      this.showOverlay = false;
    }, 50);
    setTimeout(() => {
      this.overlayClosing = false;
    }, 1500);
  }

  clearCaches(key = null) {
    const keys = this.storageKeys();
    if (keys.length > 0) {
      const hasFilter = notEmptyString(key);
      keys
        .filter((k) => !hasFilter || key === k)
        .forEach((k) => {
          switch (k) {
            case "user":
            case "submission":
              break;
            default:
              this.$ls.remove(k);
              break;
          }
        });
      if (!hasFilter) {
        this.sync();
      }
    }
  }

  linkSelected(e) {
    if (e.target instanceof HTMLElement) {
      const { tagName } = e.target;
      if (tagName.toLowerCase() === "a") {
        this.showMainNav = false;
      }
    }
  }

  toggleOverlay() {
    if (this.showOverlay) {
      this.closeOverlay();
    } else {
      bus.$emit('open-overlay', true);
      this.showOverlay = true;
    }
  }

  get loggedInHint(): string {
    let str = "";
    if (this.isLoggedIn) {
      str = `Logged in as ${this.user.fullName} (${this.user.identifier})`;
    }
    return str;
  }

  get loginWelcome(): string {
    let str = "";
    if (this.isLoggedIn && this.submission instanceof Object) {
      let shortName = (!this.isGroupMode && notEmptyString(this.submission.firstName)) ? this.submission.firstName : this.user.fullName;
      if (notEmptyString(shortName)) {
        if (shortName.length > 4) {
          shortName = shortName.split(' ').shift();
        }
        str = [this.site.label('site__hello', "Hello"), shortName].join(', ');
      }
      
    }
    return str;
  }

  get mainMenu() {
    const toParts = (localPath: string) =>
      localPath.length > 2 ? localPath.substring(1).split("/") : ["home"];
    const { path } = this.$route;
    const pathSection = toParts(path).shift();
    return this.mainMenuItems
      .filter((mi) => {
        switch (mi.access) {
          case "loggedin":
            return this.isLoggedIn;
          case "loggedout":
            return !this.isLoggedIn;
          default:
            return true;
        }
      })
      .map((mi) => {
        const parts = toParts(mi.to);
        const refName = parts.join("--");
        const key = ["menu-item", refName].join("-");
        const section = parts.shift();
        const active = pathSection === section;
        const classNames = [section];
        const keys = Object.keys(mi);
        const icon = keys.includes("icon") ? mi.icon : "";
        const hasIcon = icon.length > 1;
        if (section !== refName) {
          classNames.push(refName);
        }
        if (active) {
          classNames.push("active");
        }
        return { ...mi, key, active, classNames, icon, hasIcon, refName };
      });
  }

  matchTitle() {
    if (this.site instanceof Object) {
      const sn = this.site.snippets.find((sn) => sn.key === "site__title");
      if (sn instanceof Object) {
        this.title = sn.value;
      }
    }
  }

  get isGroupMode() {
    return backend.mode === 'group';
  }

  get wrapperClasses() {
    const modeCls = this.isGroupMode? 'group-mode' : 'student-mode';
    const cls = [modeCls];
    if (this.showMainNav) {
      cls.push("show-main-nav");
    }
    if (this.showOverlay) {
      cls.push("show-overlay");
    }
    return cls;
  }

  get overlayClasses() {
    return this.overlayClosing ? ['closing'] : ['static'];
  }

  get mainClassNames() {
    const { path } = this.$route;
    const parts = path.length > 2 ? path.substring(1).split("/") : ["home"];
    const cls = [parts[0]];
    if (parts.length > 1) {
      cls.push(parts.slice(0, 2).join("--"));
    }
    if (parts.length > 2) {
      cls.push(parts.slice(0, 3).join("--"));
    }
    return cls;
  }

}
